import Button from '@platform-ui-common/components/Button/index.js';
import GenericAddressField from '@platform-ui-common/components/GenericAddressField/index.js';
import Message from '@platform-ui-common/components/Message/index.js';
import { DispatchFieldChange, GenericFormData } from '@platform-ui-common/hooks/useForm/index.js';
import { FormProps } from '@platform-ui-common/types/index.js';
import { useState } from 'react';

const AddressFields = <FormData extends GenericFormData>({
  formData,
  dispatch,
  errors,
  id,
}: FormProps<FormData> & { id: string }): JSX.Element => {
  const [showManualAddressButton, setShowManualAddressButton] = useState(false);
  const [showManualAddressEntry, setShowManualAddressEntry] = useState(false);
  const field = { validation: { required: true } };

  return (
    <>
      <GenericAddressField
        id={id}
        field={field}
        answers={formData}
        showManualAddressButton={setShowManualAddressButton}
        showManualInput={showManualAddressEntry}
        errors={errors}
        dispatch={dispatch as unknown as DispatchFieldChange<GenericFormData>}
      />
      <div aria-live="polite">
        {showManualAddressButton && !showManualAddressEntry && (
          <>
            <div className="lg:w-field mt-4">
              <Message variant="info">
                Can’t find your address? Click the button below to manually input your address.
              </Message>
            </div>
            <Button
              variant="outline"
              onClick={(): void => setShowManualAddressEntry(!showManualAddressEntry)}
            >
              Manually input address
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default AddressFields;
